'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _sanitize_utility = require('../../../packages/common-utilities/src/sanitize_utility.js');

var _sanitize_utility2 = _interopRequireDefault(_sanitize_utility);

var _ramda = require('ramda');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericObjectiveCard = function (_React$Component) {
  _inherits(GenericObjectiveCard, _React$Component);

  function GenericObjectiveCard(props) {
    _classCallCheck(this, GenericObjectiveCard);

    return _possibleConstructorReturn(this, (GenericObjectiveCard.__proto__ || Object.getPrototypeOf(GenericObjectiveCard)).call(this, props));
  }

  _createClass(GenericObjectiveCard, [{
    key: 'render',
    value: function render() {
      var contentId = this.props.cardId + '-content';
      return _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: this.props.headerLabel,
          headerTitleId: this.props.cardId,
          headerTitleLabel: this.props.cardId,
          headerLabel: "",
          breakpoint: this.props.breakpoint,
          disclosureText: this.props.disclosureText,
          placementId: this.props.dataTest,
          shouldAlwaysShowMore: this.props.shouldAlwaysShowMore
        },
        _react2.default.createElement(
          'div',
          { 'data-testid': contentId, id: contentId },
          this.renderContent(this.props.cardContent)
        )
      );
    }
  }, {
    key: 'formatContent',
    value: function formatContent(content) {
      if (!(0, _ramda.isNil)(content)) {
        if (content.indexOf("~~") > -1) {
          var orderedContent = '<ul><li class="margin-bottom-10"><span class="text-middle">' + content + '</span></li></ul>';
          return orderedContent.replace(/~~/g, '</span></li><li class="margin-bottom-10"><span class="text-middle">');
        } else {
          return '<span class="text-middle">' + content + '</span>';
        }
      } else {
        return "";
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent(cardContent) {
      if (cardContent !== 'Not Applicable') {
        var objectiveHTML = '<span class="text-middle margin-bottom-10 riskProfileItemContainer"><p>' + cardContent + '</p></span>';
        objectiveHTML = this.formatContent(objectiveHTML);
        var content = _react2.default.createElement('div', { 'data-testid': 'fund-objective-card-content',
          dangerouslySetInnerHTML: { __html: _sanitize_utility2.default.runSanitizer(objectiveHTML) } });
        return content;
      } else if (cardContent === 'Not Applicable') {
        return null;
      }
    }
  }]);

  return GenericObjectiveCard;
}(_react2.default.Component);

exports.default = GenericObjectiveCard;